type UserFailureMap<R> = {
  serverFailure: () => R;
  networkFailure: () => R;
  wrongPasswordFailure: () => R;
};

type UserFailureMaybeMap<R> = {
  serverFailure?: () => R;
  networkFailure?: () => R;
  wrongPasswordFailure?: () => R;
  orElse: () => R;
};

abstract class _UserFailure extends Error {
  public abstract map<R>(callbacks: UserFailureMap<R>): R;
  public abstract maybeMap<R>(callbacks: UserFailureMaybeMap<R>): R;
}

class ServerFailure extends _UserFailure {
  constructor() {
    super("ServerFailure");
  }

  public map<R>(callbacks: UserFailureMap<R>): R {
    return callbacks.serverFailure();
  }

  public maybeMap<R>(callbacks: UserFailureMaybeMap<R>): R {
    if (callbacks.serverFailure) return callbacks.serverFailure();
    return callbacks.orElse();
  }
}

class NetworkFailure extends _UserFailure {
  constructor() {
    super("NetworkFailure");
  }

  public map<R>(callbacks: UserFailureMap<R>): R {
    return callbacks.networkFailure();
  }

  public maybeMap<R>(callbacks: UserFailureMaybeMap<R>): R {
    if (callbacks.networkFailure) return callbacks.networkFailure();
    return callbacks.orElse();
  }
}

class WrongPasswordFailure extends _UserFailure {
  constructor() {
    super("WrongPasswordFailure");
  }

  public map<R>(callbacks: UserFailureMap<R>): R {
    return callbacks.wrongPasswordFailure();
  }

  public maybeMap<R>(callbacks: UserFailureMaybeMap<R>): R {
    if (callbacks.wrongPasswordFailure) return callbacks.wrongPasswordFailure();
    return callbacks.orElse();
  }
}

export type UserFailure = ServerFailure | NetworkFailure | WrongPasswordFailure;

export const UserFailure = {
  serverFailure: () => new ServerFailure(),
  networkFailure: () => new NetworkFailure(),
  wrongPasswordFailure: () => new WrongPasswordFailure(),
};
